import { AppRoute } from '@app/core/routing/AppRoute';
import { DeviceViewPage } from '@app/modules/streamer-box/screens/device-view/DeviceViewPage';
import { DevicesListPage } from '@app/modules/streamer-box/screens/devices-list/DevicesListPage';
import { UserRole } from '@mi-front/core';
import { Redirect, Route, Switch } from 'react-router-dom';

export function StreamerBoxRoutes() {
  return (
    <Route path="/streamer-box">
      <Switch>
        <AppRoute
          allowedRole={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}
          exact
          path="/streamer-box/devices"
          component={DevicesListPage}
        />
        <AppRoute
          allowedRole={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}
          path="/streamer-box/devices/:id"
          component={DeviceViewPage}
        />
        <Redirect to="/streamer-box/devices" />
      </Switch>
    </Route>
  );
}
